import(/* webpackMode: "eager" */ "/vercel/path0/src/app/quy-trinh/tim-ung-vien-nhanh/page.tsx");
